export interface TaxLiability {
  taxPeriod: string;
  dueDate: string;
  amount: number;
  status: 'DUE' | 'PAID';
}

export interface Payment {
  date: string;
  taxType: 'PAYE' | 'VAT';
  amount: number;
  reference: string;
}

export interface ApiResponse<T> {
  data: T;
  lastUpdated: string;
}

export interface TenantBranding {
  headerLogoUrl: string | null;
  footerLogoUrl: string | null;
  footerBackgroundColour: string;
  footerTextColour: string;
  copyrightText: string | null;
  contactUrl: string | null;
  contactText: string;
}

export interface TenantConfig {
  displayName: string;
  passwordProtected: boolean;
  compliancePackUrl: string | null;
  faviconUrl: string | null;
  appleTouchIconUrl: string | null;
  branding: TenantBranding;
}

export const DEFAULT_BRANDING: TenantBranding = {
  headerLogoUrl: null,
  footerLogoUrl: null,
  footerBackgroundColour: '#333333',
  footerTextColour: '#ffffff',
  copyrightText: null,
  contactUrl: null,
  contactText: 'contact us',
};
